module.exports = __webpack_public_path__ + "static/media/icn_map.89bd4040.svg";